window.theme = window.theme || {}, window.theme.sections = window.theme.sections || {}, window.theme.sections.quotes = window.theme.sections.quotes || [], document.querySelectorAll(".m-quotes .quotes-wrapper").forEach((e => {

  theme.waitForElement('body.swiper--enabled').then(() => { 
  window.theme.sections.quotes[`${e.dataset.id}`] = new theme.vendor.Swiper(e, {
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: !1,
    centerInsufficientSlides: !1,
    loop: !0,
    keyboard: {
      enabled: !0,
      onlyInViewport: !0
    },
    effect: "fade",
    fadeEffect: {
      crossFade: !0
    },
    autoplay: {
      delay: 4e3
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: !0
    }
  });
  });
}));